import { render, staticRenderFns } from "./BioUpgradeBanner.vue?vue&type=template&id=7f0d72b8&scoped=true&"
import script from "./BioUpgradeBanner.vue?vue&type=script&lang=js&"
export * from "./BioUpgradeBanner.vue?vue&type=script&lang=js&"
import style0 from "./BioUpgradeBanner.vue?vue&type=style&index=0&id=7f0d72b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0d72b8",
  null
  
)

export default component.exports